import React, { ReactNode } from 'react';
import { Title } from 'ui-library';
import './PageTitle.css';

const PageTitle = ({ children = null } : { children: ReactNode }) => (
    <Title className="page-title">{children}</Title>
);

export default PageTitle;
